import { Stack } from "@bvhi/ui-base";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "../../../hooks/use-toast";
import { Route } from "../../../routes/_public/home";
import { HomepageCard } from "./components/homepage-card";
import { LoginCard } from "./components/login-card.tsx";
import { RegistrationCard } from "./components/registration-card.tsx";

export const HomepageView = () => {
  const { t } = useTranslation(["toasts"]);
  const { loggedOut } = Route.useSearch();
  const navigate = useNavigate();
  const { pushCustomSuccessToast } = useToast();

  useEffect(() => {
    if (loggedOut) {
      pushCustomSuccessToast(t("toasts:toasts.logged.out"));
      void navigate({ to: ".", search: { loggedOut: false } });
    }
  }, [loggedOut, navigate, pushCustomSuccessToast, t]);

  return (
    <Stack spacing={2}>
      <HomepageCard />
      <LoginCard />
      <RegistrationCard />{" "}
    </Stack>
  );
};
